const PrivacyPolicyPage = () => {
  return (
    <div className="pt-32 pb-24" data-testid="privacy-policy-page">
      <div className="chaleur-container">
        <div className="max-w-3xl mx-auto">
          <p className="caption text-primary mb-4">Legal</p>
          <h1 className="text-4xl md:text-5xl font-light mb-8">Privacy Policy</h1>
          <p className="text-muted-foreground mb-12">Last updated: February 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-light mb-4">1. Introduction</h2>
              <p className="text-muted-foreground leading-relaxed">
                Chaleur ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website chaleur.online and make purchases from our store.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">2. Information We Collect</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                We collect information you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Name, email address, phone number, and shipping address when you place an order</li>
                <li>Payment information (processed securely through our payment provider)</li>
                <li>Account information if you create an account</li>
                <li>Communication preferences and correspondence with us</li>
                <li>Information you provide when contacting customer support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">3. How We Use Your Information</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Process and fulfill your orders</li>
                <li>Send order confirmations and shipping updates</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Send marketing communications (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">4. Information Sharing</h2>
              <p className="text-muted-foreground leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only with service providers who assist us in operating our business (payment processors, shipping carriers, email service providers) and only to the extent necessary for them to perform their services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">5. Data Security</h2>
              <p className="text-muted-foreground leading-relaxed">
                We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">6. Your Rights</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent where applicable</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">7. Cookies</h2>
              <p className="text-muted-foreground leading-relaxed">
                We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">8. Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have questions about this Privacy Policy or our data practices, please contact us at:
              </p>
              <div className="mt-4 p-6 bg-secondary/30 border border-border">
                <p className="font-medium">Sabina Kamal</p>
                <p className="text-muted-foreground">Email: sabinakamal@gmail.com</p>
                <p className="text-muted-foreground">Phone: +91 98107 50707</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
